import React from "react";
import PropTypes from "prop-types";
import { ColumnPropTypes } from "../../props";

import { v4 as uuidv4 } from "uuid";

import Tr from "./row/tr";
import Td from "./row/td";

function getField(column, item) {
  let text = null;

  if (column.hasOwnProperty("field")) {
    if (item.hasOwnProperty(`${column.field}`)) {
      text = item[column.field];
    }
  }

  return text;
}

function isDisplay(column, data, item, i) {
  let isDisplayNeed = true;
  let prevItem = i > 0 ? data[i - 1] : null;

  if (column.hasOwnProperty("display")) {
    isDisplayNeed = column.display({
      i,
      item,
      prevItem
    });
  }

  return isDisplayNeed;
}

function Tbody({ columns, data, onClickRow }) {
  let rows = [];

  if (data && data.length) {
    let cols = [];

    data.forEach((item, i) => {
      cols = [];

      for (let column of columns) {
        let field = getField(column, item);

        if (column.hasOwnProperty("isRenderAsRow")) {
          let prevItem = i > 0 ? data[i - 1] : null;

          if (column.hasOwnProperty("display")) {
            if (isDisplay(column, data, item, i)) {
              if (column.hasOwnProperty("render")) {
                let renderedRow = column.render({
                  i,
                  item,
                  field,
                  prevItem
                });

                rows.push(renderedRow);
              }
            }
          } else {
            if (column.hasOwnProperty("render")) {
              let renderedRow = column.render({
                i,
                item,
                field,
                prevItem
              });

              rows.push(renderedRow);
            }
          }
        } else {
          if (column.hasOwnProperty("display")) {
            if (isDisplay(column, data, item, i)) {
              cols.push(
                <Td
                  key={uuidv4()}
                  column={column}
                  text={field}
                  item={item}
                  i={i}
                />
              );
            }
          } else {
            cols.push(
              <Td
                key={uuidv4()}
                column={column}
                text={field}
                item={item}
                i={i}
              />
            );
          }
        }
      }

      if (cols.length) {
        rows.push(
          <Tr onClickRow={onClickRow} item={item} key={uuidv4()}>
            {cols}
          </Tr>
        );
      }
    });
  }

  return <tbody>{rows}</tbody>;
}

Tbody.defaultProps = {
  onClickRow: () => {},
  columns: []
};

Tbody.propTypes = {
  onClickRow: PropTypes.func,
  // Колонки
  columns: PropTypes.arrayOf(ColumnPropTypes).isRequired
};

export default Tbody;
